module.exports = __webpack_public_path__ + "static/wishlistWhite-20ca09a97018526e42b36f4a16a7c6b7.png";